import { render, staticRenderFns } from "./methodtzbs.vue?vue&type=template&id=015908c5&scoped=true&"
import script from "./methodtzbs.vue?vue&type=script&lang=js&"
export * from "./methodtzbs.vue?vue&type=script&lang=js&"
import style0 from "./methodtzbs.vue?vue&type=style&index=0&id=015908c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015908c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015908c5')) {
      api.createRecord('015908c5', component.options)
    } else {
      api.reload('015908c5', component.options)
    }
    module.hot.accept("./methodtzbs.vue?vue&type=template&id=015908c5&scoped=true&", function () {
      api.rerender('015908c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/print/components/methodtzbs.vue"
export default component.exports